import { Box, Card, CardHeader, CardContent, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, FormControl, TextField, InputLabel, Button, Select, MenuItem, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { LocalizationProvider, TimePicker, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import jobService from "../../../data/api/job.service";
import { ReleaseFolder } from "../../../data/interfaces/jobmodels";
import { DropdownModel } from "../../../data/interfaces/sharedmodels";
import { useAppDispatch } from "../../../stores/hooks";
import { showsuccessmessage } from "../../../stores/notificationslice";
import { ReleaseTableContext } from "./releasemain";

export default function ReleaseTables() {
    const { releaseFileNames, setIsCreateJob } = useContext(ReleaseTableContext);
    const [date, setDate] = useState<Dayjs>(dayjs(new Date()));
    const [releaseFolder, setReleaseFolder] = useState<ReleaseFolder>({ VersionNo: 1, UtsDate: 1, ReleaseName: '' });
    const [description,setDescription]=useState<string>('')
    const dispatch = useAppDispatch();

    
    useEffect(() => {
        getVersionNo();
    }, []);
    useEffect(() => {
        getVersionNo();
    }, [date]);

    useEffect(()=>{
        if((description==null||description.length<1)&&releaseFolder.UtsDate>1){
            setDescription('Release Job for '+releaseFolder.ReleaseName);
        }
    },[releaseFolder]);

    



    const getVersionNo = () => {
        jobService.getReleaseFolder(date.toDate()).then((response) => {
            if (response && response.data) {
                setReleaseFolder(response.data)
            }
        })
    }
    

    const createReleaseJob = () => {
        jobService.initiateReleaseJob(date.toDate(), releaseFolder.VersionNo,
            releaseFileNames.flatMap(a => { return Number.parseInt(a.Id) }),description).then((response) => {
                dispatch(showsuccessmessage("Release job created with job number :" + response.data));
                setIsCreateJob(false);
            })
    }

    return (
        <Box>
            <Card>
                <CardHeader title={<Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant="h6">Tables</Typography>
                        <Typography variant="body1" color='GrayText' fontSize={14}>{releaseFolder.ReleaseName}</Typography>
                    </Box>

                    <Button onClick={createReleaseJob} variant="contained" disabled={releaseFileNames.length < 1}>Release</Button>
                </Box>}
                    size="small"></CardHeader>
                <CardContent>
                    <Box>
                        <Box sx={{ display: 'flex', mb: 2 }}>
                            <div className="datepickerclass" >
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker label="Release Date" disablePast onChange={(value) => setDate(value ?? dayjs(new Date()))} sx={{ width: '100%' }} format="MMM D, YYYY" defaultValue={date} />
                                </LocalizationProvider>
                            </div>
                        </Box>
                        <Box sx={{ display: 'flex', mb: 1 }}>
                            <FormControl size="small" sx={{ mr: 1 }}>
                                <TextField label="UTS Date" value={releaseFolder.UtsDate} inputProps={{ readOnly: true }} size="small" type="number" sx={{ backgroundColor: '#ececf1' }} />
                            </FormControl>

                            <FormControl size="small">
                                <TextField label="Version" value={releaseFolder.VersionNo} inputProps={{ readOnly: true }} size="small" type="number" sx={{ backgroundColor: '#ececf1' }} />
                            </FormControl>

                        </Box>
                        <TextField value={description} fullWidth multiline maxRows={2} inputProps={{maxlength:50}} label="Description" onChange={(event)=>setDescription(event.target.value)}/>


                    </Box>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">File Name</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {releaseFileNames.map((table) => {
                                    return (
                                        <TableRow>
                                            <TableCell sx={{ p: '5px' }}>{table.Description}</TableCell>
                                        </TableRow>
                                    )
                                })

                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
        </Box>
    )
}